import axiosInstance from '../Config/AxiosInstance';

const PREFIX = '/clinic/authors';
export const saveCannedText = data => {
  return axiosInstance.post(PREFIX + `/canned-text`, data);
};

export const getCannedtextCollections = (page, size, type, search) => {
  return axiosInstance.get(PREFIX + `/canned-text`, {
    params: { page, size, type, search }
  });
};
// Returns all key-to-phrases (active + inactive) in a single call, no pagination.
export const getAllCannedText = (type = 'allMine') => {
  return axiosInstance.get(PREFIX + `/canned-text`, {
    params: { type }
  });
};
export const targetEndPoints = () => {
  return axiosInstance.get(PREFIX + '/canned-text/target-end-points');
};

export const saveCannedTextActiveList = cannedTextIds => {
  return axiosInstance.put(
    PREFIX + `/canned-text/active?cannedTextIds=${cannedTextIds}`
  );
};

export const removeCannedTextActiveList = cannedTextIds => {
  return axiosInstance.put(
    PREFIX + `/canned-text/in-active?cannedTextIds=${cannedTextIds}`
  );
};
export const editCannedText = data => {
  return axiosInstance.put(PREFIX + `/canned-text`, data);
};
export const exportedCannedText = data => {
  return axiosInstance.patch(PREFIX + `/canned-text/exported`, data);
};
export const authorsCollectionToMyCollection = (
  cannedTextIds,
  overRideExisting,
  active,
  exportToOtherAuthors
) => {
  return axiosInstance.post(
    PREFIX +
      `/canned-text/import?active=${active}&cannedTextIds=${cannedTextIds}&overRideExisting=${overRideExisting}&exportToOtherAuthors=${exportToOtherAuthors}`
  );
};
export const removeCannedTexts = (cannedTextIds, deleteFromOtherAuthors = false) => {
  return axiosInstance.delete(
    PREFIX + `/canned-text?cannedTextIds=${cannedTextIds}&deleteFromOtherAuthors=${deleteFromOtherAuthors}`
  );
};

export const saveDictationTemplate = data => {
  return axiosInstance.post(PREFIX + `/section-template`, data);
};
export const myCollectionToActive = templateIds => {
  return axiosInstance.put(
    PREFIX + `/section-template/active?templateIds=${templateIds}`
  );
};
export const removeTemplatesFromActiveList = templateIds => {
  return axiosInstance.put(
    PREFIX + `/section-template/in-active?templateIds=${templateIds}`
  );
};
export const editDictationTemplate = data => {
  return axiosInstance.put(PREFIX + `/section-template`, data);
};
// export const listDictationTemplate = (type, page, size, search) => {
//   return axiosInstance.get(
//     PREFIX +
//       `/section-template?
//       ${type ? `type=${type}` : ''}
//       ${page ? `page=${page}` : ''}
//       ${size ? `&size=${size}` : ''}
//       ${search ? `&search=${search}` : ''}`
//   );
// };
export const listDictationTemplate = (type, page, size, search) => {
  let url = PREFIX + '/section-template?';

  if (type) url += `type=${type}&`;
  if (page) url += `page=${page}&`;
  if (size) url += `size=${size}&`;
  if (search) url += `search=${search}`;

  // Remove the trailing '&' if it exists
  if (url.endsWith('&')) {
    url = url.slice(0, -1);
  }

  return axiosInstance.get(url);
};
export const deleteDictationTemplateedit = id => {
  return axiosInstance.delete(PREFIX + `/section-template/${id}`);
};
export const removeDictationTemplate = (id, deleteFromOtherAuthors = false) => {
  return axiosInstance.delete(
    PREFIX +
      `/section-template?templateIds=${id}&deleteFromOtherAuthors=${deleteFromOtherAuthors}`
  );
};
export const authorsCollectionToMyCollectionDict = (
  cannedTextIds,
  overRideExisting,
  active,
  exportToOtherAuthors
) => {
  return axiosInstance.post(
    PREFIX +
      `/section-template/import?overRideExisting=${overRideExisting}&templateIds=${cannedTextIds}&active=${active}&exportToOtherAuthors=${exportToOtherAuthors}`
  );
};
export const getSupportedSections = () => {
  return axiosInstance.get(PREFIX + `/section-template/system-headings`);
};
export const templateMappingStatus = () => {
  return axiosInstance.get(PREFIX + `/canned-text/template-mapping`);
};
export const getListOfCannedText = (
  heading = 'Default',
  page = 0,
  size = 10,
  templateId = 'None'
) => {
  const url = `/clinic/authors/canned-text/template-specific`;
  const params = {
    heading,
    page,
    size,
    templateId
  };

  return axiosInstance.get(url, { params });
};

export const getTemplates = tenantId => {
  return axiosInstance.get(`/api/tenants/${tenantId}/templates`);
};

export const createTemplate = data => {
  return axiosInstance.post(`/api/tenants/${data.tenantId}/templates`, data);
};
